module.exports = __webpack_public_path__ + "static/media/5.ea07b136.png";